import { gql } from '@apollo/client';

export const UPDATE_PROGRAM_NEW_STATS = gql`
  mutation updateProgram($input: ProgramInput) {
    updateProgram(input: $input) {
      program {
        id
      }
    }
  }
`;
